import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { LocationEffects } from './location.effects';
import { ILocationFeature } from './location.feature.state';
import { locationReducer } from './location.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ILocationFeature>('locationFeature'), locationReducer),
    EffectsModule.forFeature([LocationEffects]),
  ],
})
export class LocationStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: LocationStateModule
  ) {
    if (parentModule) {
      throw new Error('LocationStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
